import { HttpResponse } from '@angular/common/http';

export function salesInsightsFileName(contentDisposition: string | null | undefined, fallback: string): string {
  if (!contentDisposition) {
    return fallback;
  }
  const encoded = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(contentDisposition);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim().replace(/^"|"$/g, ''));
    } catch {
      return fallback;
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(contentDisposition);
  return plain ? plain[1].trim() : fallback;
}

export function salesInsightsSaveResponse(response: HttpResponse<Blob>, fallback: string): void {
  if (!response.body) {
    return;
  }
  const url = URL.createObjectURL(response.body);
  const link = document.createElement('a');
  link.href = url;
  link.download = salesInsightsFileName(response.headers.get('Content-Disposition'), fallback);
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url));
}
